import {SimplePageHeader,} from '@flexinet/ui-components';
import {usePageHeaderTools} from "../hooks/usePageHeaderTools.tsx";
import {moduleConfig} from "../config";


export const IndexPageHeader = () => {
    const {tools} = usePageHeaderTools();

    return (
        <SimplePageHeader
            title={moduleConfig.titles.plural}
            tools={tools}
        />
    );
};